export const frontmatter = {
    "draft": true,
    "title": "Security Audit",
    "description": "Security and access event logging in OnnIA.",
    "sidebar_label": "Security Audit",
    "sidebar_group": "reference",
    "sidebar_order": 7
}

export const toc = []